module.exports = __webpack_public_path__ + "static/Karol-Andrade-866c659d1fb3c1bd2d2281edfb0031f2.png";